import request from '@/shared/api/request';

export const deleteDatabaseSnapshot = (database_uuid: string, snapshot_id: number): Promise<void> =>
  request({
    url: `/databases/${database_uuid}/snapshots/${snapshot_id}`,
    method: 'DELETE',
  });
